export const OPCOES_TELA_RENDA = 'OPCOES_TELA_RENDA';
export const OPCOES_CARD = 'OPCOES_CARD';
export const RESETA_OPCOES_TELA_RENDA = 'RESETA_OPCOES_TELA_RENDA';
export const OPCOES_TELA_BENEFICIARIOS = 'OPCOES_TELA_BENEFICIARIOS';
